import store from '@/store/index';
import btnAuthority from '@/modules/mdm/btnAuthority.js';
import otherUtils from '@/modules/mdm/utils/otherCommonFunc.js';
export const config = {
    name: 'contractManage',
    searchFields: [
        {
            name: '数据月份',
            value: 'dataMonth',
            isFixed: true,
            type: 'date',
            timeType: 'month',
            startPlaceholder: '数据月份',
            endPlaceholder: '数据月份',
            format: 'yyyy-MM',
            valueFormat: 'yyyy-MM',
            span: 4
        },
        {
            name: '操作类型',
            value: 'operationTypes',
            multiple: true,
            optionNum: 'LCRM_INC_OPERATION_TYPE',
            type: 'select',
            isFixed: true,
            span: 5
        },
        {
            name: '数据类型',
            value: 'dataTypes',
            isFixed: true,
            optionNum: 'SYNC_BIG_DATA_TYPE',
            type: 'select',
            multiple: true,
            span: 5
        },
        {
            name: '审批状态',
            value: 'approvalStatus',
            optionNum: 'LCRM_MIP_STATUS',
            type: 'select',
            multiple: true,
            span: 5,
            isFixed: true
        },
        {
            name: '执行状态',
            value: 'execStatus',
            optionNum: 'SYNC_BIG_DATA_STATUS',
            type: 'select',
            multiple: true,
            span: 5,
            isFixed: true
        },
        {
            name: '创建人',
            value: 'createUserName',
            type: 'advanceUser',
            span: 4
        },
        {
            name: '创建时间',
            value: 'createTime',
            type: 'time',
            time: 'daterange',
            startPlaceholder: '创建时间从',
            endPlaceholder: '创建时间到',
            span: 5
        },
        {
            name: '修改时间',
            value: 'updateTime',
            type: 'time',
            time: 'daterange',
            startPlaceholder: '修改时间从',
            endPlaceholder: '修改时间到',
            span: 5
        }
    ],
    selection: false,
    index: false,
    columns: [
        {
            label: '单据编号',
            prop: 'billCode',
            sortable: true,
            type: 'slot',
            slot: true,
            editSlot: true,
            width: 130,
            sort: true
        },
        {
            label: '单据标题',
            prop: 'billTitle',
            type: 'input',
            slot: false,
            editSlot: false,
            width: 140,
            sort: true
        },
        {
            label: '数据月份',
            prop: 'dataMonth',
            type: 'slot',
            editSlot: true,
            width: 160,
            sort: true
        },
        {
            label: '操作类型',
            prop: 'operationType',
            type: 'slot',
            slot: true,
            editSlot: true,
            optionsKey: 'LCRM_INC_OPERATION_TYPE', // TODO
            width: 120,
            sort: true
        },
        {
            label: '数据类型',
            prop: 'dataType',
            type: 'slot',
            slot: true,
            editSlot: true,
            optionsKey: 'SYNC_BIG_DATA_TYPE', // TODO
            width: 120,
            sort: true
        },
        {
            label: '审批状态',
            prop: 'approvalStatus',
            type: 'slot',
            slot: true,
            editSlot: true,
            optionsKey: 'LCRM_MIP_STATUS',
            width: 100,
            sort: true
        },
        {
            label: '执行状态',
            prop: 'execStatus',
            type: 'slot',
            slot: true,
            editSlot: true,
            optionsKey: 'SYNC_BIG_DATA_STATUS',
            width: 100,
            sort: true
        },
        {
            label: '导入文件',
            prop: 'respDataManageFileDetailVos',
            type: 'slot',
            slot: true,
            editSlot: true,
            width: 150,
            sort: true
        },
        {
            label: '备注',
            prop: 'remark',
            inputType: 'textarea',
            type: 'slot',
            editSlot: true,
            rows: 3,
            width: 180,
            sort: true
        },
        {
            label: '其他附件',
            prop: 'otherFile',
            type: 'slot',
            slot: true,
            editSlot: true,
            width: 150,
            sort: true
        },
        {
            label: '创建人',
            prop: 'createUserName',
            width: 90,
            sort: true
        },
        {
            label: '创建时间',
            prop: 'createTime',
            sortable: true,
            width: 154,
            sort: true
        },
        // {
        //     label: '修改人',
        //     prop: 'updateUserName',
        //     width: 140
        // },
        {
            label: '修改时间',
            prop: 'updateTime',
            sortable: true,
            width: 154,
            sort: true
        },
        {
            label: '执行说明',
            prop: 'execResult',
            sortable: true,
            width: 154,
            sort: true
        }
    ],
    actions: { // 表格操作列的配置
        fixedWidth: 200, // fixedWidth（可选） 设置操作列的固定宽度，不加该参数默认是按钮list长度*50px
        list: [
            // { 1: '草稿', 2: '待审批', 3: '审批中', 4: '审批通过', 5: '审批驳回', 6: '撤回', 7: '作废' };
            {
                label: '保存',
                event: 'save',
                displayRule: (row) => {
                    if (row.edit === 2 && [1, 5, 6, 7].includes(+row.approvalStatus)) {
                        return true;
                    }
                }
            },
            {
                label: '删除',
                event: 'delete',
                displayRule: (row) => {
                    // （1）判断审批状态=待审批/审批中/审批通过时，禁止删除；
                    // （2）判断执行状态=进行中/已完成时，禁止删除；
                    // （3）判断有关联审批流程，且流程状态不等于废弃时，禁止删除；
                    if (otherUtils.getHasAuth(btnAuthority.customerPersonResponsibleData.delete) && [1, 5, 6, 7].includes(+row.approvalStatus) && [1].includes(+row.execStatus)) {
                        return true;
                    }
                }
            },
            {
                label: '导出',
                event: 'export',
                displayRule: (row) => {
                    if (otherUtils.getHasAuth(btnAuthority.customerPersonResponsibleData.export) && row.id) {
                        return true;
                    }
                }
            },
            {
                label: '审批',
                event: 'verity',
                displayRule: (row) => {
                    // 当执行状态=就绪时显示可用；否则禁用；
                    // （1）判断审批状态=待审批/审批中/审批通过时，禁止审核；
                    // （2）判断执行状态=进行中/已完成时，禁止审核；
                    // { 1: '草稿', 2: '待审批', 3: '审批中', 4: '审批通过', 5: '审批驳回', 6: '撤回', 7: '作废' };
                    if (otherUtils.getHasAuth(btnAuthority.customerPersonResponsibleData.verify) && [1, 5, 6, 7].includes(+row.approvalStatus) && [1].includes(+row.execStatus)) {
                        return true;
                    }
                }
            }
        ]
    },
    PANELMAX: 8,
    LASTFOUR: 4,
    LASTSIX: 6
};
